/*
  Listado de carreras Deporbox.
  Conecta las secciones de la página:
  - [data-dbx-race-group]  sección de una distancia (data-key, data-label) con tarjetas [data-dbx-race] (data-city)
  - [data-dbx-race-filter] barra de filtros (genera los botones de distancia y ciudad)
  - [data-dbx-race-target] tarjetas de la cabecera que llevan a una distancia (data-target)
  - [data-dbx-race-meta]   textos con [carreras] y [ciudades] que se rellenan solos
  Admite ?distancia=10k&ciudad=madrid en la URL.
*/
(function () {
  var state = { distance: null, city: null };

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function norm(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function groups() {
    return $all('[data-dbx-race-group]');
  }

  function cardsOf(group) {
    return $all('[data-dbx-race]', group);
  }

  function fill(template, values) {
    return String(template || '')
      .replace(/\[(\w+)\]/g, function (m, key) {
        return key in values ? values[key] : m;
      })
      // Singular en español: «1 carreras» → «1 carrera», «1 ciudades» → «1 ciudad»
      .replace(/\b1 carreras\b/g, '1 carrera')
      .replace(/\b1 ciudades\b/g, '1 ciudad');
  }

  function pill(label, active, disabled) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dbx-rf__pill' + (active ? ' is-active' : '');
    b.setAttribute('aria-pressed', active ? 'true' : 'false');
    if (disabled) {
      b.disabled = true;
      b.classList.add('is-disabled');
    }
    b.textContent = label;
    return b;
  }

  function cityList() {
    var seen = {};
    var list = [];
    groups().forEach(function (g) {
      cardsOf(g).forEach(function (c) {
        var city = c.getAttribute('data-city');
        var key = norm(city);
        if (city && !seen[key]) {
          seen[key] = true;
          list.push(city);
        }
      });
    });
    return list.sort(function (a, b) {
      return a.localeCompare(b, 'es');
    });
  }

  function matchesCity(card) {
    return !state.city || norm(card.getAttribute('data-city')) === norm(state.city);
  }

  function renderFilters() {
    $all('[data-dbx-race-filter]').forEach(function (bar) {
      var distWrap = bar.querySelector('[data-dbx-distance-pills]');
      var cityWrap = bar.querySelector('[data-dbx-city-pills]');
      var countEl = bar.querySelector('[data-dbx-race-count]');
      var showCounts = bar.getAttribute('data-show-counts') !== 'false';

      if (distWrap) {
        distWrap.innerHTML = '';
        var total = 0;
        var perGroup = groups().map(function (g) {
          var n = cardsOf(g).filter(matchesCity).length;
          total += n;
          return { key: g.getAttribute('data-key'), label: g.getAttribute('data-label'), n: n };
        });
        var allBtn = pill(bar.getAttribute('data-all-label') + (showCounts ? ' · ' + total : ''), !state.distance, false);
        allBtn.addEventListener('click', function () {
          state.distance = null;
          apply();
        });
        distWrap.appendChild(allBtn);
        perGroup.forEach(function (g) {
          if (!g.key) return;
          var b = pill(g.label + (showCounts ? ' · ' + g.n : ''), state.distance === g.key, g.n === 0);
          b.addEventListener('click', function () {
            state.distance = state.distance === g.key ? null : g.key;
            apply();
          });
          distWrap.appendChild(b);
        });
      }

      if (cityWrap) {
        cityWrap.innerHTML = '';
        var allCity = pill(bar.getAttribute('data-city-all-label'), !state.city, false);
        allCity.addEventListener('click', function () {
          state.city = null;
          apply();
        });
        cityWrap.appendChild(allCity);
        cityList().forEach(function (city) {
          // Ciudades sin carreras en la distancia elegida aparecen desactivadas
          var available = groups().some(function (g) {
            if (state.distance && g.getAttribute('data-key') !== state.distance) return false;
            return cardsOf(g).some(function (c) {
              return norm(c.getAttribute('data-city')) === norm(city);
            });
          });
          var b = pill(city, norm(state.city) === norm(city), !available);
          b.addEventListener('click', function () {
            state.city = norm(state.city) === norm(city) ? null : city;
            apply();
          });
          cityWrap.appendChild(b);
        });
      }

      if (countEl) {
        var visible = 0;
        groups().forEach(function (g) {
          if (!g.hidden) visible += cardsOf(g).filter(function (c) { return !c.hidden; }).length;
        });
        countEl.textContent = fill(visible === 1 ? bar.getAttribute('data-count-one') : bar.getAttribute('data-count'), { n: visible });
      }

      var reset = bar.querySelector('[data-dbx-race-reset]');
      if (reset) reset.hidden = !state.distance && !state.city;
    });
  }

  function renderMeta() {
    $all('[data-dbx-race-meta]').forEach(function (el) {
      var key = el.getAttribute('data-target');
      var cards = [];
      groups().forEach(function (g) {
        if (!key || g.getAttribute('data-key') === key) cards = cards.concat(cardsOf(g));
      });
      var cities = {};
      cards.forEach(function (c) {
        cities[norm(c.getAttribute('data-city'))] = true;
      });
      el.textContent = fill(el.getAttribute('data-template'), {
        carreras: cards.length,
        ciudades: Object.keys(cities).length
      });
    });
  }

  function apply() {
    groups().forEach(function (g) {
      var groupMatch = !state.distance || g.getAttribute('data-key') === state.distance;
      var visible = 0;
      cardsOf(g).forEach(function (c) {
        var show = groupMatch && matchesCity(c);
        c.hidden = !show;
        if (show) visible++;
      });
      g.hidden = !groupMatch || visible === 0;
      var sub = g.querySelector('[data-dbx-group-count]');
      if (sub) {
        var cities = {};
        cardsOf(g).forEach(function (c) {
          if (!c.hidden) cities[norm(c.getAttribute('data-city'))] = true;
        });
        sub.textContent = fill(sub.getAttribute('data-template'), {
          carreras: visible,
          ciudades: Object.keys(cities).length
        });
      }
    });
    var empty = document.querySelector('[data-dbx-race-empty]');
    if (empty) {
      empty.hidden = groups().some(function (g) {
        return !g.hidden;
      });
    }
    renderFilters();
  }

  function scrollToGroup(key) {
    var target = groups().filter(function (g) {
      return g.getAttribute('data-key') === key;
    })[0];
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function init() {
    // Filtros desde la URL
    try {
      var params = new URLSearchParams(window.location.search);
      var d = norm(params.get('distancia'));
      var c = norm(params.get('ciudad'));
      if (d) {
        groups().forEach(function (g) {
          if (norm(g.getAttribute('data-key')) === d) state.distance = g.getAttribute('data-key');
        });
      }
      if (c) {
        cityList().forEach(function (city) {
          // Admite el nombre completo o con guiones (ej. donostia-san-sebastian → Donostia)
          var key = norm(city).replace(/\s+/g, '-');
          if (key === c || c.indexOf(key + '-') === 0) state.city = city;
        });
      }
    } catch (e) {}

    renderMeta();
    apply();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-dbx-race-target]');
    if (link) {
      var key = link.getAttribute('data-dbx-race-target');
      var exists = groups().some(function (g) {
        return g.getAttribute('data-key') === key;
      });
      if (!exists) return;
      e.preventDefault();
      state.distance = null;
      state.city = null;
      apply();
      scrollToGroup(key);
      return;
    }
    var reset = e.target.closest('[data-dbx-race-reset]');
    if (reset) {
      state.distance = null;
      state.city = null;
      apply();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Editor de temas: recalcular al añadir, quitar o reordenar secciones y bloques
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(function () {
        renderMeta();
        apply();
      }, 50);
    });
  });
})();
